import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  ITEM_TITLE_CLASS,
  TItemTitleProps,
} from "@/ui/components/data-display/Item/Item.config";

export const ItemTitle: FC<TItemTitleProps> = (
  {
    className,
    children,
    ...props
  },
) => (
  <p
    {...props}
    data-component="ItemTitle"
    className={cn(ITEM_TITLE_CLASS, className)}
  >
    { children }
  </p>
);

ItemTitle.displayName = "ItemTitle";
